import React, { useContext, useEffect, useState } from 'react';

import MUIDataTable from "mui-datatables";
import { Box, Link, Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faPlay, faStop, faThList, faTicket, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';


export default function CashlessTransactionsDataTable({transactions})
{
    const columns = [
        {
            name : 'created_at',
            label : 'Fecha',
            options : 
            {
                filter:false,
                searchable:true
            }
        },
        {
            name : 'creator.name',
            label : 'Operador',
            options:{
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        transactions[dataIndex].creator.name
                    );
                },
                filter:true,
                searchable:true
            }
        },
        {
            name : 'customer.name',
            label : 'Cliente',
            options:{
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        transactions[dataIndex].customer.name
                    );
                },
                filter:true,
                searchable:true
            }
        },
        {
            name : 'type',
            label : 'Tipo',
            options:{
                filter:true,
                //filterType:'dropdown',
                display:true,
                searchable:true
            }
        },
        {
            name : 'status',
            label : 'Estatus',
            
            options:{
                filter:true
            }
        },
        
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        };


    return(
        <>
            <MUIDataTable
            
                title={"Listado de transactions"}
                data={transactions}
                columns={columns}
                options={options}
            />
        </>
    )
}